import { useContext } from 'react';

import { LumxFormContext } from '../utils/FormContext';

export const useFormContext = () => {
    const context = useContext(LumxFormContext);

    return context;
};
